import * as React from 'react'
import { getStaticSlugsPaths } from '../../../helpers/nextHelpers'
import type { SlugsStaticType } from '../../../helpers/nextHelpers'
import { withRouter } from 'next/router'
import type { BookDetailPropsType } from '../../../models/Book'
import { getBookDetailPropsAsync, getBookSlugsAsync } from '../../../models/Book'
import DiscoverLayout from '@components/Discover/DiscoverLayout'
import { BookDetails } from '@components/Book/BookDetails'
function Book (props: BookDetailPropsType): React.ReactNode {
  return (
    <DiscoverLayout background title={`Read ${props.title} on Dipsea`} description={`Read ${props.title} on Dipsea. ${props.description}`} imageUrl={props.imageUrl}>
      <BookDetails {...props} />
    </DiscoverLayout>
  )
}
export default withRouter(Book as any) as any

type ContextType = {
  params: {
    slug: string
  }
}
export async function getStaticProps (
  context: ContextType
): Promise<{ props: BookDetailPropsType }> {
  const book = await getBookDetailPropsAsync(context.params.slug)
  return { props: book }
}
export async function getStaticPaths (): Promise<SlugsStaticType> {
  const slugs = await getBookSlugsAsync()
  return getStaticSlugsPaths(slugs)
}
